<template>
  <v-main class="pa-0">
    <v-container fluid class="pa-0">
      <v-toolbar class="elevation-0">
        <v-toolbar-title class="pl-0">Renegociações</v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="d-flex mr-n4 align-center">
          <v-select
            style="width: 250px; margin-right: 10px"
            label="Arrecadação"
            v-model="selectedJoined"
            :items="joinedOptions"
            outlined dense
            hide-details
          ></v-select>
          <v-select
            style="width: 200px; margin-right: 10px"
            label="Categoria"
            v-model="selectedCategory"
            :items="categoryOptions"
            outlined dense
            hide-details
          ></v-select>
          <v-select
            style="width: 150px"
            label="Competências"
            v-model="selectedDate"
            :items="allowedDates[selectedJoined]"
            outlined dense
            hide-details
          ></v-select>
          <v-btn text color="primary" @click="addItem = true">
            <v-icon left>mdi-plus-circle-outline</v-icon> Adicionar item
          </v-btn>
        </div>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="items"
        :items-per-page.sync="pagination.rowsPerPage"
        no-data-text="Sem renegociações para essa arrecadação"
        no-results-text="Sem renegociações para essa arrecadação"
        loading-text="Carregando..."
        :loading="loading"
        :footer-props="{ itemsPerPageOptions: [10, 20, 30] }"
        :server-items-length="pagination.total"
        :page.sync="pagination.page"
      >
        <template v-slot:item.actions="{ item }">
          <template v-if="item.generated_invoice">
            <v-btn fab small text color="primary" @click="invoiceJoinItem = { id: item.id, show: true }">
              <v-icon>mdi-set-center</v-icon>
            </v-btn>
            <v-btn v-if="item.generated_invoice.id" fab small text color="primary" :to="{ name: 'invoiceDetails', params: { id: item.generated_invoice.id } }">
              <v-icon>mdi-file-find</v-icon>
            </v-btn>
            <v-btn v-if="item.generated_invoice.invoice_url" fab small text color="primary" :href="item.generated_invoice.invoice_url" target="_blank">
              <v-icon>mdi-barcode</v-icon>
            </v-btn>
          </template>
          <template v-else>
            <v-btn fab small text color="primary" @click="invoiceJoinItem = { id: item.id, show: true }">
              <v-icon>mdi-set-center</v-icon>
            </v-btn>
            <v-btn fab small text color="primary" @click="editItem = { id: item.id, item, show: true }">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn fab small text color="error" @click="deleteItem = { id: item.id, text: 'essa negociação', show: true }">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </template>
        <template v-slot:item.category="{ item }">
          {{ item.category | installmentCategory }}
        </template>
        <template v-slot:item.description="{ item }">
          {{ item.description || 'Sem descrição' }}
        </template>
        <template v-slot:item.installment_amount="{ item }">
          {{ item.installment_amount | price }}
        </template>
        <template v-slot:item.due_date="{ item }">
          {{ item.due_date | moment('MM/YYYY') }}
        </template>
        <template v-slot:item.updated_at="{ item }">
          {{ item.updated_at | moment('DD/MM/YYYY hh:mm:ss') }}
        </template>
      </v-data-table>
    </v-container>
    <add-modal
      :joineds="joinedOptions"
      :selectedJoined="selectedJoined"
      :allowedDates="allowedDates"
      v-if="addItem"
      @canceled="addItem = false"
      @error="addItem = false"
      @finished="addItem = false; getData()"
    ></add-modal>
    <edit-modal
      :id="editItem.id"
      :item="editItem.item"
      :joineds="joinedOptions"
      :allowedDates="allowedDates"
      v-if="editItem.show"
      @canceled="editItem.show = false"
      @error="editItem.show = false"
      @edited="editItem.show = false; getData()"
    ></edit-modal>
    <delete-modal
      title="Negociação"
      endpoint="financial-negotiations"
      :text="deleteItem.text"
      :id="deleteItem.id"
      v-if="deleteItem.show"
      @canceled="deleteItem.show = false"
      @error="deleteItem.show = false"
      @deleted="deleteItem.show = false; getData()"
    ></delete-modal>
    <invoice-join-modal
      :id="invoiceJoinItem.id"
      v-if="invoiceJoinItem.show"
      @canceled="invoiceJoinItem.show = false"
      @error="invoiceJoinItem.show = false"
      @edited="invoiceJoinItem.show = false; getData()"
    ></invoice-join-modal>
  </v-main>
</template>

<script>
import axios from 'axios'
import AddModal from '@/components/EditModals/RenegotiationAdd'
import EditModal from '@/components/EditModals/RenegotiationEdit'
import InvoiceJoinModal from '@/components/EditModals/RenegotiationInvoiceJoin'
import DeleteModal from '@/components/DeleteModal'

export default {
  name: 'renegotiations',
  components: {
    AddModal,
    EditModal,
    DeleteModal,
    InvoiceJoinModal
  },
  props: ['joineds'],
  data: () => ({
    joinedOptions: [],
    selectedJoined: '',
    allowedDates: {},
    selectedDate: '',
    categoryOptions: [
      { value: '', text: 'Todos' },
      { value: 'additional', text: 'Adicional' },
      { value: 'renegotiation', text: 'Renegociação' },
      { value: 'interest_and_fines', text: 'Multa/juros' },
      { value: 'discount', text: 'Desconto' }
    ],
    selectedCategory: '',
    loading: false,
    items: [],
    headers: [
      {
        text: '',
        sortable: false,
        value: 'actions'
      },
      {
        text: 'Categoria',
        sortable: false,
        value: 'category'
      },
      {
        text: 'Descrição',
        sortable: false,
        value: 'description'
      },
      {
        text: 'Valor total',
        sortable: false,
        align: 'right',
        value: 'installment_amount'
      },
      {
        text: 'Competência',
        sortable: false,
        value: 'due_date'
      },
      {
        text: 'Atualizado em',
        sortable: false,
        value: 'updated_at'
      }
    ],
    pagination: {
      rowsPerPage: 30,
      page: 1,
      total: 0,
      sortBy: [],
      sortDesc: []
    },
    addItem: false,
    editItem: {
      item: {},
      id: null,
      show: false
    },
    deleteItem: {
      text: null,
      id: null,
      show: false
    },
    invoiceJoinItem: {
      id: null,
      show: false
    }
  }),
  computed: {
    additionalFilters () {
      let additionalFilters = 'page[size]=' + this.pagination.rowsPerPage
      additionalFilters += '&page[number]=' + this.pagination.page
      additionalFilters += '&filter[joined_id]=' + this.selectedJoined
      additionalFilters += (this.selectedCategory) ? '&filter[category]=' + this.selectedCategory : ''
      additionalFilters += (this.selectedDate) ? '&filter[due_date]=' + this.selectedDate + ',' + this.selectedDate.substring(0, 7) + '-20' : ''
      return additionalFilters
    }
  },
  watch: {
    additionalFilters () {
      this.getData()
    }
  },
  methods: {
    getData () {
      this.loading = true
      axios.get('/financial-negotiations?' + this.additionalFilters)
        .then(response => {
          this.items = response.data.data
          this.pagination.total = response.data.meta.total
          this.loading = false
        })
        .catch(() => {
          this.items = []
          this.pagination.total = 0
          this.loading = false
        })
    }
  },
  created () {
    const joinedLenght = this.joineds.length

    if (joinedLenght > 0) {
      for (let i = 0; i < joinedLenght; i++) {
        this.joinedOptions.push({
          text: this.joineds[i].name,
          value: this.joineds[i].joined_id
        })
        this.allowedDates[this.joineds[i].joined_id] = []
        this.allowedDates[this.joineds[i].joined_id].push({
          text: 'Todas',
          value: '',
          year: '',
          month: ''
        })
        console.log(this.joineds[i])
        if (this.joineds[i].method && this.joineds[i].number_of_installment) {
          const now = new Date()
          let year = now.getFullYear()
          let month = now.getMonth() + 1
          if (now.getDate() < 5) {
            if (month <= 1) {
              month = 11
              year--
            } else {
              month--
            }
          }
          for (let j = 0; j <= this.joineds[i].number_of_installment; j++) {
            this.allowedDates[this.joineds[i].joined_id].push({
              text: (month < 10 ? '0' + month : month) + '/' + year,
              value: year + '-' + (month < 10 ? '0' + month : month) + '-01',
              year,
              month
            })
            if (month >= 12) {
              month = 1
              year++
            } else {
              month++
            }
          }
        }
      }
      this.selectedJoined = this.joinedOptions[0].value
      this.getData(this.selectedJoined)
    }
  }
}
</script>
